import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import requestUtils from 'api/requestUtils'
import { sum } from 'lib/array/arrayUtils'

type Response = paths['/api/lux-loyalty/customer/{customerId}/order/{orderId}']['get']['responses']['200']['content']['application/json']

/**
 * Retrieves all loyalty data about a specific order
 */
async function requestLoyaltyOrderDetails(orderId: string, memberId: string): Promise<App.OrderLoyaltyDetails> {
  return requestUtils.get<Response>(
    `/api/lux-loyalty/customer/${memberId}/order/${orderId}`,
    { credentials: 'include' },
  ).then((response): App.OrderLoyaltyDetails => {
    const basePointsTotal = sum(response.result.pendingPoints, pending => pending.points)
    const bonusPointsTotal = sum(response.result.pendingPoints, pending => pending.bonusPoints)
    const statusCreditsTotal = sum(response.result.pendingPoints, pending => pending.statusCredits)
    const bonusStatusCreditsTotal = sum(response.result.pendingPoints, pending => pending.bonusStatusCredits)

    return {
      benefitsRedeemed: response.result.benefitsRedeemed.map((benefit): App.OrderLoyaltyBenefit => ({
        amount: benefit.currencyAmount,
        itemId: benefit.itemId,
        status: benefit.status,
        code: benefit.benefitCode as App.LoyaltyBenefitType,
      })),
      pointsSpent: response.result.pointsSpent.map((points): App.OrderLoyaltyPointsSpent => ({
        amount: points.currencyAmount,
        itemId: points.itemId,
        points: points.pointsAmount,
        status: points.status,
      })),
      airportTransfer: !!(response.result.airportTransferRequest && response.result.airportTransferRequest?.status !== 'FAILED'),
      pendingPoints: {
        points: basePointsTotal + bonusPointsTotal,
        basePoints: basePointsTotal,
        bonusPoints: bonusPointsTotal,
        statusCredits: statusCreditsTotal + bonusStatusCreditsTotal,
        items: response.result.pendingPoints.map((points): App.OrderLoyaltyPendingPoints => {
          const basePoints = points.points
          const bonusPoints = points.bonusPoints
          const statusCredits = points.statusCredits
          const bonusStatusCredits = points.bonusStatusCredits

          return {
            itemId: points.itemId,
            basePoints,
            bonusPoints,
            statusCredits,
            bonusStatusCredits,
            points: basePoints + bonusPoints,
            status: points.status,
            pointsEarnDate: points.pointsEarnDate ?? null,
          }
        }),
      },
    }
  })
}

export default requestLoyaltyOrderDetails
